export const SECTIONS = [
  { slug: "uk-news", name: "UK News", blurb: "Reporting from towns, cities and estates across the country." },
  { slug: "world", name: "World", blurb: "Stories from further afield, told with the same care." },
  { slug: "opinion", name: "Opinion", blurb: "Argument and analysis, clearly labelled as such." },
];

export const sectionName = (slug) => SECTIONS.find((s) => s.slug === slug)?.name || slug;
